import { Stack, TextField, Typography } from "@mui/material"
import { useFormikContext } from "formik";
import { OnboardingFormValues } from "../Onboarding";

const getIndustryName = (id: string) => {
    switch (id) {
        case 'restaurant':
            return 'Restaurante';
        case 'other':
            return 'Comercio';
        default:
            return 'Restaurante';
    }
}

const OrganizationNameStep = () => {
    const { values, setFieldValue } = useFormikContext<OnboardingFormValues>();

    return (
        <Stack spacing={3}>
            <Typography textAlign="center" variant="h1" color="white">
                {`¿Cómo se llama ${values.industry === 'coffee-shop' ? 'la' : 'el'} ${getIndustryName(values.industry)}?`}
            </Typography>
            <TextField
                placeholder={`Escribe aquí el nombre de tu ${getIndustryName(values.industry)}`}
                value={values.title}
                onChange={(e) => {
                    setFieldValue('title', e.target.value);
                }}
            />
        </Stack>
    )
}

export default OrganizationNameStep;
